import { useContext } from "react";
import { RlNavContext } from "../RlNav";

const useRlNavContext = () => {
  const context = useContext(RlNavContext);
  if (!context)
    throw new Error(
      "useRlNavContext must be used within a RlNavContext.Provider"
    );
  return context;
};

export default useRlNavContext;
